<template>
  <v-autocomplete
    v-model="model"
    :items="items"
    :item-title="itemTitle"
    :item-value="itemValue"
    :label="label"
    :rules="rules"
    :disabled="disabled"
    :loading="loading"
    variant="outlined"
    density="compact"
    color="primary"
    rounded
    :search="search"
    @update:search="onSearch"
    @update:menu="onMenuUpdate"
  >
    <template #append-item>
      <div
        v-if="hasNext && !loading"
        ref="loadTrigger"
        style="height: 1px;"
      ></div>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  props: {
    modelValue: [String, Number],
    storeModule: { type: String, required: true },
    action: { type: String, required: true },
    itemsState: { type: String, required: true },
    label: String,
    itemTitle: { type: [String, Function], required: true },
    itemValue: { type: String, required: true },
    rules: Array,
    disabled: Boolean
  },

  emits: ["update:modelValue"],

  data() {
    return {
      search: "",
      page: 1,
      limit: 20,
      observer: null,
      debounceTimer: null,
      isFetching: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit("update:modelValue", value)
      }
    },
    items() {
      return this.$store.state[this.storeModule][this.itemsState]
    },
    loading() {
      return this.$store.state[this.storeModule].loading
    },
    hasNext() {
      return this.$store.state[this.storeModule].hasNext
    }
  },

  methods: {
    async loadData(reset = false) {
        if (this.loading || this.isFetching) return

        this.isFetching = true

        if (reset) {
            this.page = 1
        }

        let searchValue = this.search

        if (this.model) {
            searchValue = this.model
        }

        await this.$store.dispatch(`${this.storeModule}/${this.action}`, {
            search: searchValue,
            page: this.page,
            limit: this.limit,
            reset
        })

        if (this.hasNext) {
            this.page++
        }

        this.isFetching = false
    },

    onSearch(value) {
      clearTimeout(this.debounceTimer)

      this.search = value

      this.debounceTimer = setTimeout(() => {
        this.loadData(true)
      }, 400)
    },

    onMenuUpdate(isOpen) {
        if (!isOpen) return

        this.loadData(true)

        this.$nextTick(() => {
            this.initObserver()
        })
    },

    initObserver() {
        this.$nextTick(() => {
            if (!this.$refs.loadTrigger) return

            if (this.observer) {
            this.observer.disconnect()
            }

            this.observer = new IntersectionObserver((entries) => {
            const entry = entries[0]

            if (entry.isIntersecting && this.hasNext && !this.loading && !this.isFetching) {
                this.loadData(false)
            }
            })

            this.observer.observe(this.$refs.loadTrigger)
        })
    }
  },
  watch: {
    items() {
      this.$nextTick(() => {
        this.initObserver()
      })
    }
 }
}
</script>